module.exports = __webpack_public_path__ + "static/media/om_eyeshape_hooded_amber.76bc88e4.png";